<template>
<div style="background-color: transparent;">
  <lazyTileGrid @loadMore="getNextResults" :itemsCount="resAmount"  :items="items" v-if="items[0] && (items[0].depictionID || items[0].caveID || items[0].iconographyID)" ></lazyTileGrid>
  <v-expansion-panels Focusable multiple v-if="!(items[0].depictionID || items[0].caveID || items[0].iconographyID)">
        <v-expansion-panel
        v-for="(item,i) in items"
        :key="i"
        >
        <v-expansion-panel-header>
          <v-row >
            <v-col>
              <div  v-html="getTitle(item)"></div>
            </v-col>
            <v-col v-if="item.depictionID" cols=2>
              <v-img width="100%" height="100%"  style="opacity:1" :src="thumbnailDic[item.depictionID]" position="left" contain>
              </v-img>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <depictionInf v-if="false" :depiction="item" :presentCave="presentCave" :preSelected="preselectedAnnotations"></depictionInf>
            <caveInf v-if="false" :caveDefault="item" ></caveInf>
            <bibliographyInf v-if="item.annotatedBibliographyID" :bibliographyDefault="item" :showDepictions = "showRelatedItems"></bibliographyInf>
            <iconographyInf v-if="item.iconographyID" :iconography="item" ></iconographyInf>
        </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</div>
</template>
<script>
import { reactive } from "vue";
import {getBibTitle, getCaveLabel, getDepictionLabel} from  "@/utils/helpers"
import caveInf from '@/components/caveInf'
import lazyTileGrid from "./lazyTileGrid.vue";
import depictionInf from '@/components/depictionInf'
import iconographyInf from '@/components/iconographyInf'
import bibliographyInf from '@/components/bibliographyInf'

export default {
  name: 'relatedItems',
  props: {
    resAmount: {
      type: Number,
      default: 0
    },
    items: {},
    presentCave:{
      type: Boolean,
      default: false
    },
    preselectedAnnotations:{
      type: Array,
      default: function(){
        return []
      }
    },
    showRelatedItems:{
      type: Boolean,
      default: false
    }
  },
  components: {
    "depictionInf":depictionInf,
    iconographyInf,
    bibliographyInf,
    caveInf,
    lazyTileGrid,
  },

  data () {
    return {
      showAddInf: false,
      showAnno: false,
      tab:[],
      viewerImg:{},
      thumbnailDic: reactive({}),
    }
  },
  computed: {
  },
  methods: {
    getNextResults(from, size) {
      this.$log.debug("initiated next results", from, size);
      this.$emit("getNextResults", from, size);
    },
    async fetchThumbnail(image, sessionId) {
      console.log("fetchThumbnail", image, process.env.VUE_APP_IIIFAPI + "/iiif/2/kucha%2Fimages%2F" + image.filename + "/full/150,/0/default.jpg");
      const headers = new Headers();
      if (sessionId && sessionId !== "") headers.set('Authorization', `Bearer ${sessionId}`);

      try {

        const res = await fetch(process.env.VUE_APP_IIIFAPI + "/iiif/2/kucha%2Fimages%2F" + image.filename + "/full/300,/0/default.jpg", { headers });
        console.log("res", res)
        if (!res.ok) throw new Error("Failed to fetch image");

        const binaryData = await res.arrayBuffer();
        return "data:image/jpg;base64," + btoa(String.fromCharCode(...new Uint8Array(binaryData)));
      } catch (error) {
        console.error("Fehler beim Laden des Thumbnails:", error);
        return null; // Fallback-Bild im Fehlerfall
      }
    },
    getThumbNail(item) {
      if (item.depictionID) {
        let masterImage = null;
        for (const image of item.relatedImages) {
          if (image.imageID === item.masterImageID) {
            masterImage = image;
            break;
          }
        }
        if (masterImage !== null) {
          let masterLoadable = false
          if (masterImage.filename !== "accessNotPermitted.png") {
            if (masterImage.accessLevel === 2){
              masterLoadable = true
            }
            if (this.$store.state.user.sessionID) {
              if (masterImage.accessLevel > 1) {
                masterLoadable = true
              }
            }
          }
          if (masterLoadable) {

            return this.fetchThumbnail(masterImage, this.$store.state.user.sessionID)
              .then(res=> {
                this.$log.debug("getThumbnail", item.depictionID, " : ", res);
                this.$set(this.thumbnailDic, item.depictionID, res);
              }).catch(function (error) {
                console.log(error)
                return null
              })
          } else {
            return null;
          }
        } else {
          return null;
        }
      } else {
        return null;
      }
    },

    getTitle(item){
      // this.$log.debug(item);
      if (item.depictionID) {
        return getDepictionLabel(item)
      } else if (item.caveID) {
        return "cave " + getCaveLabel(item)
      } else if (item.iconographyID) {
        return "Iconography Entry " + item.iconographyID + " (" + item.text + ")"
      } else if (item.annotatedBibliographyID) {
        return getBibTitle(item)
      } else {
        return "unknown item"
      }
    }
  },
  mounted:function () {
    this.$log.debug("related items:", this.items);
    for (const item of this.items) {
      if (item.depictionID) {
        // this.getThumbNail(item);
      }
    }
  },
}
</script>

<style lang="css" scoped>

.v-list-item__title{
  margin-bottom: 5px;
}
.v-tab {
  padding: 8px;
  min-width: 20px;
}
</style>
